// COMPONENTS
import * as ComponentLibrary from "@picnicmedia/masanatemples123";
// TYPES
import { BuildMethod } from "../types";

interface Props {
  value: BuildMethod;
  onChange: (value: BuildMethod) => void;
  /* Locked once a creative exists (build method is chosen at creation only). */
  disabled?: boolean;
}

/**
 * JH (30-07-26)
 * The fork at the top of the New Ad FORMAT step: build with a Picnic template, or upload a pre-built
 * HTML5 package. Selecting "Custom" swaps the whole template flow for the package inspector.
 */
export function BuildMethodToggle({ value, onChange, disabled }: Props) {
  const option = (key: BuildMethod, label: string, sublabel: string, icon: string) => {
    const active = value === key;
    return (
      <button
        type="button"
        disabled={disabled}
        onClick={() => !disabled && onChange(key)}
        className={`flex-auto tl pa3 br3 pointer platform-font ${active ? "white background-color-primary-3" : "dark-gray bg-white"}`}
        style={{ border: `1px solid ${active ? "transparent" : "#e3e3e3"}`, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled && !active ? 0.5 : 1 }}>
        <div className="flex items-center">
          <ComponentLibrary.PCIconPicker icon={icon as any} />
          <span className="ml2 fw6 f5">{label}</span>
        </div>
        <div className={`f7 mt1 ${active ? "white" : "mid-gray"}`} style={active ? { opacity: 0.85 } : {}}>
          {sublabel}
        </div>
      </button>
    );
  };

  return (
    <ComponentLibrary.PCContainerMain>
      <ComponentLibrary.PCSpacer type={"padding"} position={"around"} size={4}>
        <ComponentLibrary.PCHeader text={"Build method"} />
        <ComponentLibrary.PCSpacer type={"margin"} position={"top"} size={3} />
        <div className="flex" style={{ gap: "12px" }}>
          {option("template", "Template Library", "Build with a Picnic format", "table-cells")}
          {option("custom", "Custom", "Upload a pre-built HTML5 ad", "upload")}
        </div>
      </ComponentLibrary.PCSpacer>
    </ComponentLibrary.PCContainerMain>
  );
}
